import {EditGroupDialog} from "../models/dialogs/EditGroupDialog.js";
import JSX from "../helpers/react.js";
import {askQuestion, handleFetchError, showNotice} from "../helpers/functions.js";
import {ServerApi} from "../api.js";

$(document).on('click', '.edit-group-btn', function (){
    document.body.appendChild(
        (<EditGroupDialog currentRoles={$("#page_user_roles").attr('content')!.split(',') as any[]} OnSuccess={()=>window.location.reload()}/>)
    );
})

$(document).on('click', '.edit-nickname-btn', async function (){
    try {
        const ans = await askQuestion("Изменение никнейма",
            <>
                Правила для никнеймов:<br/>
                - В никах не должна присутствовать нецензурная лексика (как прямая, так и завуалированная),
                оскорбительные выражения (в том числе расистского характера), текст связанный с порнографией.
                <br />
                - Ваш ник не должен подделывать существующие ники (использовать ники, трудноразличимые
                написанием от ника какого-либо другого пользователя)
                <br />
                - Никнеймы можно менять раз в месяц
                <br />
                - Ник должен быть <b>уникальным</b> в пределах сайта, минимальная длина <b>3</b> символа, максимальная — <b>16</b> символов, можно использовать нижнее подчеркивание, точку, пробел, цифры и латиницу (кирилица, иероглифы и другие символы запрещены)
            </>,
            "Изменить",
            "Новый никнейм"
        );
        await ServerApi.users.update(page_id!, {nickname: ans});
        showNotice(<>Никнейм успешно изменён.</>, 'Успех', 'success');
        setTimeout(()=>window.location.reload(), 1000);
    }
    catch (e){
        if(e !== 'Canceled')
            handleFetchError(e);
    }
});


